import React, { useState } from "react"
import IconFont from "../elements/IconFont"
import { MailIcon } from "../Icons"
import { Modal } from "../elements/Modal"
import { UserInvitation } from "../../types"
import useInvites from "../hooks/invites/useInvites"
import useAcceptInvite from "../hooks/invites/useAcceptInvite"
import useRejectInvite from "../hooks/invites/useRejectInvite"

export interface ViewInvitesProps {
  className?: string
  onOpen?: () => void
}

const ViewInvites: React.FC<ViewInvitesProps> = ({ className = '', onOpen = () => { } }: ViewInvitesProps): React.ReactElement => {

  const { invites } = useInvites()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const acceptInvite = useAcceptInvite()
  const rejectInvite = useRejectInvite()

  const handleAcceptInvite = async (invite: UserInvitation): Promise<void> => {
    acceptInvite({ inviteId: invite.verificationId })
  }

  const handleCancelInvite = async (invite: UserInvitation): Promise<void> => {
    rejectInvite({ workspaceId: invite.workspace.id, email: invite.email })
  }

  const handleOnClickElement = async (): Promise<void> => {
    onOpen()
    setIsOpen(true)
  }

  const handleCloseElement = (): void => {
    setIsOpen(false)
  }

  return (
    invites.length ? (
      <div className={className}>
        <button onClick={handleOnClickElement} className="flex items-center leading-[22px] text-xs font-semibold text-accent" type="button">
          <MailIcon />
          <span className="mx-1">View invites</span>
        </button>
        <Modal
          open={isOpen}
          onClose={handleCloseElement}
          title="Workspace Invites"
          subtitle="Invites not accepted after 7 days get cancelled automatically and need to be reinitiated by a workspace owner."
          titleAlign="start"
        >
          <div className="mt-[16px] flex w-full flex-col gap-[8px] text-md">
            {invites ? <>
              {invites.length === 0 && <h2>No invites found</h2>}
              {invites.map((invite, index) => (
                <div key={index} className={"flex flex-row items-center justify-between " + invite.workspace ? "" : "hidden"}>
                  {invite.workspace ? <>
                    <div className="grid grid-cols-[5%_95%] items-center justify-start">
                      <IconFont name="layers-2" size={16} className="flex justify-start items-center" />
                      <span className="px-2 text-lg truncate">{invite.workspace.name}</span>
                    </div>
                    <div className="grid grid-cols-2 gap-4 my-2">
                      <button className="btn-secondary" onClick={() => handleCancelInvite(invite)}>Cancel</button>
                      <button className="btn-primary" onClick={() => handleAcceptInvite(invite)}>Accept</button>
                    </div></> : <></>}
                </div>
              ))}
            </>
              : <h2>No invites found</h2>}
          </div>
        </Modal>
      </div>
    ) : <></>
  )
}

export default ViewInvites
